import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Heading } from '@/components/ui/shared/heading';
import React from 'react';
import { Button } from '@/components/ui/button';
import { ChevronLeft, Loader2 } from 'lucide-react';
import { useUserState } from '@/components/context/UserContext';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import ComplexBuyerInfo from '../Components/ComplexBuyerInfo';
import { useCartData } from '../../CartPage/context/CartDataContext';
import { ComplexItemInfo } from '../Components/ComplexItemInfo';

export default function ComplexPatientInfoStep({ goNext, goPrev }) {
  const history = useHistory();
  const userState = useUserState();
  const { complexPrice, complex, loading } = useCartData();
  const isLoggedIn = !!userState?.isLoggedIn;

  return (
    <div className="flex flex-col sm:flex-row sm:gap-4">
      <div className="sm:w-2/3">
        <Card>
          <CardHeader>
            {/* Top row: back+heading (left), login button (right on sm) */}
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <button
                  type="button"
                  onClick={() => {
                    history.goBack();
                  }}
                  className="flex items-center gap-1 hover:opacity-80 focus:outline-none"
                >
                  <ChevronLeft className="w-8 h-8 text-secondary" />
                  <Heading variant="2">Registracija paslaugai</Heading>
                </button>
              </div>

              {/* Desktop login button (only if not logged in) */}
              {!isLoggedIn && (
                <div className="hidden sm:block">
                  <Button
                    variant="light"
                    onClick={() => history.push('/selfservice')}
                  >
                    Prisijungti
                  </Button>
                </div>
              )}
            </div>

            {/* Subheading */}
            <Label variant="subheading">
              Prisijungus prie paskyros, duomenis užpildysime automatiškai.
            </Label>

            {/* Mobile login button (only if not logged in) */}
            {!isLoggedIn && (
              <div className="sm:hidden">
                <Button
                  variant="light"
                  onClick={() => history.push('/selfservice')}
                >
                  Prisijungti
                </Button>
              </div>
            )}
          </CardHeader>

          <CardContent>
            {/* onValid fires only after successful RHF/Zod validation */}
            <ComplexBuyerInfo onValid={goNext} />
          </CardContent>

          <CardFooter>
            <Button
              type="submit"
              form="patient-form-id"
              className="hidden sm:flex sm:w-full items-center justify-center gap-2"
              disabled={loading}
            >
              {loading && (
                <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
              )}
              <span>Pateikti užsakymą</span>
            </Button>
          </CardFooter>
        </Card>
      </div>

      <div className="sm:w-1/3 mt-2 sm:mt-0">
        <ComplexItemInfo price={complexPrice}></ComplexItemInfo>
      </div>

      <div className="mt-6 sm:hidden">
        <Button type="submit" form="patient-form-id">
          Pereiti prie apmokėjimo
        </Button>
      </div>
    </div>
  );
}
